
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import SelectStudentMentorModal from "../AdminAssignMentor/StudentMentorModal/SelectStudentMentorModal";
import { ApiUrl } from "../../../ApiUrl";
const AssignStudentMentor = () => {
  // const location = useLocation();
  // const selectedStudents = location.state?.selectedStudents || [];

    const location = useLocation();

    // initialize from location.state if present
    const [selectedStudents, setSelectedStudents] = useState(
      () => location.state?.selectedStudents || []
    );


  const [mentors, setMentors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [show, setShow] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [registrationNo, setRegistrationNo] = useState("");
  const [barcode, setBarcode] = useState("");
  const [students, setStudents] = useState([]);
  const [modalStudents, setModalStudents] = useState([]);

  // const [selectedStudents, setSelectedStudents] = useState([]);
  const navigate = useNavigate();
  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

    useEffect(() => {
      if (
        location?.state?.selectedStudents &&
        location.state.selectedStudents.length > 0
      ) {
        const incoming = Array.isArray(location.state.selectedStudents)
          ? location.state.selectedStudents
          : [location.state.selectedStudents];

        setSelectedStudents((prev) => {
          const merged = [...prev];
          incoming.forEach((ns) => {
            const sid = ns?.studentBasicDetails?.id ?? ns?.student_id ?? ns?.id;
            if (
              !merged.some(
                (s) =>
                  (s?.studentBasicDetails?.id ?? s?.student_id ?? s?.id) === sid
              )
            ) {
              merged.push(ns);
            }
          });
          return merged;
        });

        // clear location.state so same modal selection won't be re-processed on next render
        navigate(location.pathname, { replace: true, state: {} });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

  // const handleClear = () => {
  //   if (dateRef.current) dateRef.current.value = "";
  //   if (fromClassRef.current) fromClassRef.current.value = "";
  //   if (toClassRef.current) toClassRef.current.value = "";
  //   if (admissionNoRef.current) admissionNoRef.current.value = "";
  //   if (barcodeRef.current) barcodeRef.current.value = "";
  //   if (smsToRef.current) smsToRef.current.checked = false;
  // };

  const handleClear = () => {
    // Reset form inputs
    setSelectedMentor(null);
    setStudentName("");
    setRegistrationNo("");
    setBarcode("");

    // Reset fetched students
    setStudents([]);
    setSelectedStudents([]);
    setModalStudents([]);

    // Optionally clear modal selection
    setShow(false);
    setShowModal(false);

    // Clear any referenced DOM elements
    if (dateRef.current) dateRef.current.value = "";
    if (fromClassRef.current) fromClassRef.current.value = "";
    if (toClassRef.current) toClassRef.current.value = "";
    if (admissionNoRef.current) admissionNoRef.current.value = "";
    if (barcodeRef.current) barcodeRef.current.value = "";
    if (smsToRef.current) smsToRef.current.checked = false;
  };

  const handleSelectStudent = (selectedStudent) => {
    const fullName = [
      selectedStudent.studentBasicDetails.first_name || "",
      selectedStudent.studentBasicDetails.middle_name || "",
      selectedStudent.studentBasicDetails.last_name || "",
    ]
      .filter(Boolean)
      .join(" ");

    setStudentName(fullName); // Set student name for display (not used for search)
    // setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
    // setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

    handleCloseModal();
  };

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const isStudentNameDisabled = !selectedMentor;

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const branchId = localStorage.getItem("branchId");
        const orgId = localStorage.getItem("orgId");

        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // const fetchStudentDetails = async () => {
  //   if (!registrationNo && !barcode) {
  //     alert("Please enter at least one value (Registration No or Barcode).");
  //     return;
  //   }

  //   try {
  //     let apiUrl = `${ApiUrl.apiurl}STUDENT_DETAILS/StudentDetailsBasedOnRegistrationNoBarcodeList/?`;
  //     if (registrationNo) apiUrl += `registration_no=${registrationNo}&`;
  //     if (barcode) apiUrl += `barcode=${barcode}`;

  //     const response = await fetch(apiUrl);
  //     const data = await response.json();

  //     if (data.message === "success") {
  //       const studentData = Array.isArray(data.data) ? data.data : [data.data];

  //       // Merge fetched students, ensuring valid student_id
  //       setStudents((prev) => {
  //         const mergedStudents = [
  //           ...prev,
  //           ...studentData.filter(
  //             (newStudent) =>
  //               !prev.some((student) => student.id === newStudent.id) &&
  //               newStudent.student_id // Ensure valid student_id
  //           ),
  //         ];
  //         console.log("Merged Students:", mergedStudents);
  //         return mergedStudents;
  //       });
  //     } else {
  //       alert("Student not found.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching student details:", error);
  //     alert("Failed to fetch student details.");
  //   }
  // };

  // const fetchStudentDetails = async () => {
  //   if (!registrationNo && !barcode) {
  //     alert("Please enter at least one value (Registration No or Barcode).");
  //     return;
  //   }

  //   try {
  //     let apiUrl = `${ApiUrl.apiurl}STUDENT_DETAILS/StudentDetailsBasedOnRegistrationNoBarcodeList/?`;
  //     if (registrationNo) apiUrl += `registration_no=${registrationNo}&`;
  //     if (barcode) apiUrl += `barcode=${barcode}`;

  //     const response = await fetch(apiUrl);
  //     const data = await response.json();

  //     if (data.message === "success") {
  //       const studentData = Array.isArray(data.data) ? data.data : [data.data];

  //       setStudents((prev) => {
  //         const mergedStudents = [
  //           ...prev,
  //           ...studentData.filter(
  //             (newStudent) =>
  //               !prev.some((student) => student.id === newStudent.id) &&
  //               newStudent.student_id
  //           ),
  //         ];
  //         return mergedStudents;
  //       });
  //     } else {
  //       alert("Student not found.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching student details:", error);
  //     alert("Failed to fetch student details.");
  //   }
  // };


  const fetchStudentDetails = async () => {
    if (!registrationNo && !barcode) {
      alert("Please enter at least one value (Registration No or Barcode).");
      return;
    }

    try {
      let apiUrl = `${ApiUrl.apiurl}STUDENT_DETAILS/StudentDetailsBasedOnRegistrationNoBarcodeList/?`;
      if (registrationNo) apiUrl += `registration_no=${registrationNo}&`;
      if (barcode) apiUrl += `barcode=${barcode}`;

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.message === "success") {
        const studentData = Array.isArray(data.data) ? data.data : [data.data];

        setStudents((prev) => {
          const mergedStudents = [
            ...prev,
            ...studentData.filter(
              (newStudent) =>
                !prev.some((student) => student.id === newStudent.id) &&
                newStudent.student_id
            ),
          ];
          return mergedStudents;
        });
      } else {
        alert("Student not found.");
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
      alert("Failed to fetch student details.");
    }
  };

  // 🔹 Add this function
  // const handleRemoveStudent = (id) => {
  //   setStudents((prev) =>
  //     prev.filter(
  //       (student) =>
  //         student?.id !== id &&
  //         student?.student_id !== id &&
  //         student?.studentBasicDetails?.id !== id
  //     )
  //   );
  // };

  // 🔹 Updated remove function
  const handleRemoveStudent = (id) => {
    setStudents((prev) =>
      prev.filter(
        (s) => (s?.studentBasicDetails?.id ?? s?.student_id ?? s?.id) !== id
      )
    );

    setModalStudents((prev) =>
      prev.filter(
        (s) => (s?.studentBasicDetails?.id ?? s?.student_id ?? s?.id) !== id
      )
    );

    setSelectedStudents((prev) =>
      prev.filter(
        (s) => (s?.studentBasicDetails?.id ?? s?.student_id ?? s?.id) !== id
      )
    );
  };


  const handleAssign = async () => {
    const createdBy = sessionStorage.getItem("userId");
    const branchId = localStorage.getItem("branchId");
    const orgId = localStorage.getItem("orgId");
    const academicYearId = localStorage.getItem("academicSessionId");

    if (!selectedMentor || !selectedMentor.value) {
      alert("Please select a mentor.");
      return;
    }

    // Merge selected and fetched students
    const allSelectedStudents = [...selectedStudents, ...students];

    if (allSelectedStudents.length === 0) {
      alert("Please select at least one student.");
      return;
    }

    // Extract student_id properly (including barcode-fetched students)
    const studentIds = allSelectedStudents
      .map(
        (student) =>
          student?.student_id || // Ensure student_id is extracted correctly
          student?.id ||
          student?.studentBasicDetails?.id ||
          student?.value
      )
      .filter(Boolean);

    if (studentIds.length === 0) {
      alert("No valid students found. Check console for details.");
      console.log(
        "All Selected Students (For Debugging):",
        allSelectedStudents
      );
      return;
    }

    // Payload Construction
    const payload = {
      teacher_id: selectedMentor.value,
      student_id: studentIds,
      academic_year_id: academicYearId,
      org_id: orgId,
      branch_id: branchId,
      date: new Date().toISOString().split("T")[0],
      created_by: createdBy,
    };

    console.log("Payload Sent to API:", payload);

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Mentor/studentmentorAssign/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      console.log("Mentor assign response:", result);

      if (result.message === "Already Exists") {
        alert(
          "Mentor already assigned to one or more of the selected students.",
        );
      } else if (
        result.message === "Success" ||
        result.message === "success" ||
        result.message === "Saved Successfully"
      ) {
        alert("Student assigned successfully!");
        handleClear();
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Assignment failed:", error);
      alert("Failed to assign students.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ASSIGN STUDENT MENTOR
              </p>
              <div className="row mb-2 mt-3 mx-0">
                <div
                  className="col-12 p-2 d-flex flex-wrap gap-2"
                  // style={{ border: "1px solid #ccc" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleAssign}
                  >
                    Assign Mentor
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/assign-mentor")}
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3 mb- 3 ">
                        <label
                          htmlFor="mentor"
                          className="form-label me-2"
                          style={{ whiteSpace: "nowrap", minWidth: "80px" }}
                        >
                          Mentor
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          onChange={setSelectedMentor}
                          placeholder="Select Mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3 mt-4">
                        <input
                          type="text"
                          id="student-name"
                          className="form-control detail"
                          placeholder="Add Multiple Student(s)"
                          value={studentName}
                          onClick={() => {
                            if (!isStudentNameDisabled) handleShow(); // Open modal on input click
                          }}
                          onChange={(e) => setStudentName(e.target.value)}
                          disabled={isStudentNameDisabled} // Disable if no mentor is selected
                          readOnly // Prevent cursor from appearing in the field
                          style={{
                            cursor: isStudentNameDisabled
                              ? "not-allowed"
                              : "pointer",
                            backgroundColor: isStudentNameDisabled
                              ? "#0d6efd"
                              : "#0d6efd",
                            caretColor: "transparent", // Hide text cursor
                          }}
                        />
                      </div>

                      <SelectStudentMentorModal
                        show={show}
                        handleClose={handleClose}
                        onSelectStudent={handleSelectStudent}
                      />
                      <div className="row">
                        <div className="col-12 col-md-4 mb-3">
                          <label
                            htmlFor="school-admission-number"
                            className="form-label"
                          >
                            Registration No
                          </label>
                          <input
                            type="text"
                            id="school-admission-number"
                            className="form-control detail"
                            placeholder="Enter admission no"
                            ref={admissionNoRef}
                            value={registrationNo}
                            onChange={(e) => setRegistrationNo(e.target.value)}
                          />
                        </div>

                        <div className="col-12 col-md-4 mb-3">
                          <label
                            htmlFor="school-barcode"
                            className="form-label"
                          >
                            School BarCode
                          </label>
                          <input
                            type="text"
                            id="school-barcode"
                            className="form-control detail"
                            placeholder="Enter school barcode"
                            ref={admissionNoRef}
                            value={barcode}
                            onChange={(e) => setBarcode(e.target.value)}
                          />
                        </div>

                        <div className="col-12 col-md-4 mb-3 mt-4">
                          <input
                            type="text"
                            id="other-input"
                            className="form-control detail text-white"
                            placeholder="Add Students"
                            onClick={fetchStudentDetails}
                            ref={admissionNoRef}
                            readOnly
                            style={{
                              backgroundColor: "#0d6efd", // Bootstrap's primary color
                              borderColor: "#0d6efd",
                              cursor: "pointer",
                              maxWidth: "150px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Student Name</th>
                        <th>BarCode</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Father Name</th>
                        <th>Mother Name</th>
                        <th>Remove</th>
                      </tr>
                    </thead>


                    {/* 🔹 Updated Table Render */}
                    <tbody>
                      {[...selectedStudents, ...students, ...modalStudents]
                        .length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No students selected.
                          </td>
                        </tr>
                      ) : (
                        [
                          ...selectedStudents,
                          ...students,
                          ...modalStudents,
                        ].map((student, index) => {
                          const sid =
                            student?.studentBasicDetails?.id ||
                            student?.student_id ||
                            student?.id;
                          return (
                            <tr key={sid || index}>
                              <td>{index + 1}</td>
                              <td>
                                {student.studentBasicDetails
                                  ? `${
                                      student.studentBasicDetails.first_name
                                    } ${
                                      student.studentBasicDetails.middle_name ||
                                      ""
                                    } ${student.studentBasicDetails.last_name}`
                                  : student.studentname}
                              </td>
                              
                              <td>
                                {student.studentBasicDetails
                                  ? student.studentBasicDetails.barcode
                                  : student.barcode}
                              </td>
                              <td>
                                {student.studentBasicDetails
                                  ? student.studentBasicDetails.classname
                                  : student.classname}
                              </td>
                              <td>
                                {student.studentBasicDetails
                                  ? student.studentBasicDetails.sectionname
                                  : student.sectionname}
                              </td>
                              <td>
                                {student.studentBasicDetails
                                  ? student.studentBasicDetails.father_name
                                  : student.father_name}
                              </td>
                              <td>
                                {student.studentBasicDetails
                                  ? student.studentBasicDetails.mother_name
                                  : student.mother_name}
                              </td>
                              <td>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => handleRemoveStudent(sid)}
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                {/* <SelectStudentMentorModal
                    show={show}
                    handleClose={() => setShow(false)}
                  /> */}
                {/* {showModal && (
                  <SelectStudentMentorModal
                    show={showModal}
                    handleClose={handleClose}
                    onSelectStudent={(student) =>
                      setStudentName(student.studentBasicDetails.first_name)
                    }
                  />
                )} */}
                {showModal && (
                  <SelectStudentMentorModal
                    show={showModal}
                    handleClose={handleClose}
                    onSelectStudent={(student) => {
                      // Store student from modal into state
                      setModalStudents((prev) => {
                        const sid =
                          student?.studentBasicDetails?.id ||
                          student?.student_id ||
                          student?.id;
                        if (
                          prev.some(
                            (s) =>
                              s?.studentBasicDetails?.id === sid ||
                              s?.student_id === sid ||
                              s?.id === sid
                          )
                        ) {
                          return prev; // avoid duplicates
                        }
                        return [...prev, student];
                      });
                      handleClose(); // close modal after select
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AssignStudentMentor;